import React from "react";
import { viewMode } from "../Helpers/SharedClasses";

export class ZoomButtons extends React.Component<
    {
        onZoomOffsetChange: (zoomFactor: number,offset: number) => void;
        onResetCurve: () => void;
        onFlipCalled: () => void;
        onFindOptimalPosition: () => void;
        onViewModeSwitch: () => void;
        onsaveImage: () => void;

        initialOffset?: number;
        zoomIncrement?: number; //it will be the scaling factor when pressing the zoom in button, the divisor for zoomout
        minZoom?: number; //can set a min or max as a decimal number equal to the scaling factor, e.g. minZoom=0.2 is 20%
        maxZoom?: number; 
        offSetIncrement?: number;
        flowViewMode: viewMode;
    },
    {
        
        
    }
> {

    zoomIn = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onZoomOffsetChange((this.props.zoomIncrement as number), 0);
            
    }

    zoomOut = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onZoomOffsetChange(1/(this.props.zoomIncrement as number), 0);
    }

    resetZoomOffset = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onResetCurve();
    }

    moveUp = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        const newOffset =  (this.props.offSetIncrement?this.props.offSetIncrement:10);
        this.props.onZoomOffsetChange(1,-newOffset);
    }

    moveDown = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        const newOffset = (this.props.offSetIncrement?this.props.offSetIncrement:10);
        this.props.onZoomOffsetChange(1,newOffset);
    }
    

    render() {
        return (
            <div className="zoom-buttons">
                <button className="intui-button zoom-in" onClick={this.zoomIn} title="Zoom in">+</button>
                <button className="intui-button zoom-out" onClick={this.zoomOut} title="Zoom out">-</button>
                <button className="intui-button zoom-reset" onClick={this.resetZoomOffset} title="Reset">↺</button>
                <button className="intui-button move-up" onClick={this.moveUp} title="Move scale up">⤉</button>
                <button className="intui-button move-down" onClick={this.moveDown} title="Move scale down">⤈</button>
                <button className="intui-button move-down" onClick={this.props.onFlipCalled} title="Flip axis">⇅</button>
                <button className="intui-button optimal-position" onClick={this.props.onFindOptimalPosition} title="Find optimal position">⌖</button>
                <button className="intui-button save-image" onClick={this.props.onsaveImage} title="Save image"><span><img alt="Screen Capture" src="/screenCapture.svg"/></span></button>
                <button className="intui-button legacy-switch" onClick={this.props.onViewModeSwitch} title="Switch view mode">{this.props.flowViewMode === viewMode.Legacy ? <span><img alt="Intui" src="/intui-icon.svg"/></span> :<span><img alt="Legacy"  src="/legacy-icon.svg"/></span>}</button>
                <div className="viewLabel">{this.props.flowViewMode === viewMode.Legacy ? <label>CLASSIC</label> :<label>INTUI</label>}</div>
                
            </div>
        );
    }
}